import type { ConnectionState, ReconnectionInstruction, SessionStatePayload } from './types';

export class ReconnectionHandler {
  private _connectionState: ConnectionState = 'connected';
  private _sessionId: string | null = null;

  get connectionState(): ConnectionState {
    return this._connectionState;
  }

  get sessionId(): string | null {
    return this._sessionId;
  }

  onSessionJoined(sessionId: string): void {
    this._sessionId = sessionId;
  }

  onSessionLeft(): void {
    this._sessionId = null;
    this._connectionState = 'connected';
  }

  onDisconnect(): void {
    this._connectionState = 'disconnected';
  }

  onReconnecting(): void {
    this._connectionState = 'reconnecting';
  }

  onReconnected(): ReconnectionInstruction | null {
    if (this._sessionId) {
      return { type: 'rejoin', sessionId: this._sessionId };
    }
    this._connectionState = 'connected';
    return null;
  }

  processSessionState(payload: SessionStatePayload): ReconnectionInstruction {
    this._connectionState = 'connected';

    switch (payload.transportState) {
      case 'playing':
        return {
          type: 'seek_and_play',
          timeMs: payload.currentTimeMs,
          sectionIndex: payload.currentSectionIndex,
        };
      case 'paused':
        return {
          type: 'seek_and_pause',
          timeMs: payload.currentTimeMs,
          sectionIndex: payload.currentSectionIndex,
        };
      case 'stopped':
        return { type: 'reset' };
    }
  }
}
